module.exports = "/packs/banner_pc_study_plan_notion-ebb2317b06ae27f763ef3f663eb30cab.png";